var exports = {
  "kR": "x28a7bf27--45f3b4--cards",
  "Nr": "x28a7bf27--45f3b4--card",
  "_8": "x28a7bf27--45f3b4--img",
  "Qq": "x28a7bf27--45f3b4--text",
  "TS": "x28a7bf27--45f3b4--rate",
};

module.exports = exports;
